<template>
    <section class="back-img between-style">
        <div class="container">
            <div class="row">
                <div class="col between-style-wrap">
                    <div class="between-style-info">
                        <h3 class="between-style-info-title">{{$t("public.try_it_section.title")}}</h3>
                        <span
                            class="between-style-info-text" v-html="$t('public.try_it_section.text')"></span>
                    </div>
                    <router-link tag="a" class="btn btn-accent btn-round-28 text-nowrap" :to="{name: 'Try-it-out'}">{{$t("public.try_it_section.btn")}}</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'TryItSection'
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Public/PublicComponets/TryItSection.vue